/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createPricingPageContent = /* GraphQL */ `
  mutation CreatePricingPageContent(
    $input: CreatePricingPageContentInput!
    $condition: ModelPricingPageContentConditionInput
  ) {
    createPricingPageContent(input: $input, condition: $condition) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const updatePricingPageContent = /* GraphQL */ `
  mutation UpdatePricingPageContent(
    $input: UpdatePricingPageContentInput!
    $condition: ModelPricingPageContentConditionInput
  ) {
    updatePricingPageContent(input: $input, condition: $condition) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const deletePricingPageContent = /* GraphQL */ `
  mutation DeletePricingPageContent(
    $input: DeletePricingPageContentInput!
    $condition: ModelPricingPageContentConditionInput
  ) {
    deletePricingPageContent(input: $input, condition: $condition) {
      id
      heroTitle
      heroDescription
      eyebrow
      heading
      introduction
      monthlyName
      monthlyDescription
      monthlyEquivalent
      monthlyBadge
      monthlyFeatures
      monthlyCta
      yearlyName
      yearlyDescription
      yearlyEquivalent
      yearlyBadge
      yearlyFeatures
      yearlyCta
      assurances
      noticeTitle
      noticeBody
      createdAt
      updatedAt
    }
  }
`;
export const createNotice = /* GraphQL */ `
  mutation CreateNotice(
    $input: CreateNoticeInput!
    $condition: ModelNoticeConditionInput
  ) {
    createNotice(input: $input, condition: $condition) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const updateNotice = /* GraphQL */ `
  mutation UpdateNotice(
    $input: UpdateNoticeInput!
    $condition: ModelNoticeConditionInput
  ) {
    updateNotice(input: $input, condition: $condition) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotice = /* GraphQL */ `
  mutation DeleteNotice(
    $input: DeleteNoticeInput!
    $condition: ModelNoticeConditionInput
  ) {
    deleteNotice(input: $input, condition: $condition) {
      id
      title
      content
      attachments
      date
      status
      deliveryTarget
      externalLink
      externalLinkLabel
      expiresAt
      isImportant
      createdAt
      updatedAt
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      type
      clarity
      videoQuality
      referralLikelihood
      difficulty
      mood
      improvement
      requestedMove
      audio
      createdAt
      updatedAt
      username
      owner
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      username
      displayName
      phoneNumber
      profileImageKey
      bio
      city
      instagramHandle
      onboardingCompleted
      country
      danceLevel
      danceExperienceYears
      danceExperienceMonths
      favoriteStyles
      trainingFrequency
      goals
      howHeardAboutUs
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createMemberAccess = /* GraphQL */ `
  mutation CreateMemberAccess(
    $input: CreateMemberAccessInput!
    $condition: ModelMemberAccessConditionInput
  ) {
    createMemberAccess(input: $input, condition: $condition) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateMemberAccess = /* GraphQL */ `
  mutation UpdateMemberAccess(
    $input: UpdateMemberAccessInput!
    $condition: ModelMemberAccessConditionInput
  ) {
    updateMemberAccess(input: $input, condition: $condition) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteMemberAccess = /* GraphQL */ `
  mutation DeleteMemberAccess(
    $input: DeleteMemberAccessInput!
    $condition: ModelMemberAccessConditionInput
  ) {
    deleteMemberAccess(input: $input, condition: $condition) {
      id
      userID
      status
      scope
      startsAt
      expiresAt
      reason
      grantedBy
      grantedAt
      revokedAt
      createdAt
      updatedAt
    }
  }
`;
export const createShowSeries = /* GraphQL */ `
  mutation CreateShowSeries(
    $input: CreateShowSeriesInput!
    $condition: ModelShowSeriesConditionInput
  ) {
    createShowSeries(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateShowSeries = /* GraphQL */ `
  mutation UpdateShowSeries(
    $input: UpdateShowSeriesInput!
    $condition: ModelShowSeriesConditionInput
  ) {
    updateShowSeries(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteShowSeries = /* GraphQL */ `
  mutation DeleteShowSeries(
    $input: DeleteShowSeriesInput!
    $condition: ModelShowSeriesConditionInput
  ) {
    deleteShowSeries(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      bannerImageUrl
      category
      externalUrl
      externalLinkLabel
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createShowEpisode = /* GraphQL */ `
  mutation CreateShowEpisode(
    $input: CreateShowEpisodeInput!
    $condition: ModelShowEpisodeConditionInput
  ) {
    createShowEpisode(input: $input, condition: $condition) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateShowEpisode = /* GraphQL */ `
  mutation UpdateShowEpisode(
    $input: UpdateShowEpisodeInput!
    $condition: ModelShowEpisodeConditionInput
  ) {
    updateShowEpisode(input: $input, condition: $condition) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteShowEpisode = /* GraphQL */ `
  mutation DeleteShowEpisode(
    $input: DeleteShowEpisodeInput!
    $condition: ModelShowEpisodeConditionInput
  ) {
    deleteShowEpisode(input: $input, condition: $condition) {
      id
      seriesID
      title
      description
      videoUrl
      videoProvider
      thumbnailUrl
      seasonNumber
      episodeNumber
      durationLabel
      releaseDate
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createInstructor = /* GraphQL */ `
  mutation CreateInstructor(
    $input: CreateInstructorInput!
    $condition: ModelInstructorConditionInput
  ) {
    createInstructor(input: $input, condition: $condition) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateInstructor = /* GraphQL */ `
  mutation UpdateInstructor(
    $input: UpdateInstructorInput!
    $condition: ModelInstructorConditionInput
  ) {
    updateInstructor(input: $input, condition: $condition) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteInstructor = /* GraphQL */ `
  mutation DeleteInstructor(
    $input: DeleteInstructorInput!
    $condition: ModelInstructorConditionInput
  ) {
    deleteInstructor(input: $input, condition: $condition) {
      id
      name
      slug
      bio
      country
      styles
      profileImageUrl
      headerImageUrl
      instagramUrl
      youtubeUrl
      websiteUrl
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createCourse = /* GraphQL */ `
  mutation CreateCourse(
    $input: CreateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    createCourse(input: $input, condition: $condition) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateCourse = /* GraphQL */ `
  mutation UpdateCourse(
    $input: UpdateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    updateCourse(input: $input, condition: $condition) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteCourse = /* GraphQL */ `
  mutation DeleteCourse(
    $input: DeleteCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    deleteCourse(input: $input, condition: $condition) {
      id
      title
      slug
      shortDescription
      description
      coverImageUrl
      trailerUrl
      difficulty
      accessLevel
      tags
      instructorIDs
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createCourseModule = /* GraphQL */ `
  mutation CreateCourseModule(
    $input: CreateCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    createCourseModule(input: $input, condition: $condition) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateCourseModule = /* GraphQL */ `
  mutation UpdateCourseModule(
    $input: UpdateCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    updateCourseModule(input: $input, condition: $condition) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteCourseModule = /* GraphQL */ `
  mutation DeleteCourseModule(
    $input: DeleteCourseModuleInput!
    $condition: ModelCourseModuleConditionInput
  ) {
    deleteCourseModule(input: $input, condition: $condition) {
      id
      courseID
      title
      description
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      courseID
      moduleID
      title
      slug
      description
      previewVideoUrl
      previewVideoProvider
      videoUrl
      videoProvider
      videoParts
      captionUrl
      captionLabel
      thumbnailUrl
      durationMinutes
      isFreePreview
      isFeatured
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createLessonView = /* GraphQL */ `
  mutation CreateLessonView(
    $input: CreateLessonViewInput!
    $condition: ModelLessonViewConditionInput
  ) {
    createLessonView(input: $input, condition: $condition) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateLessonView = /* GraphQL */ `
  mutation UpdateLessonView(
    $input: UpdateLessonViewInput!
    $condition: ModelLessonViewConditionInput
  ) {
    updateLessonView(input: $input, condition: $condition) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteLessonView = /* GraphQL */ `
  mutation DeleteLessonView(
    $input: DeleteLessonViewInput!
    $condition: ModelLessonViewConditionInput
  ) {
    deleteLessonView(input: $input, condition: $condition) {
      id
      lessonID
      viewerKey
      viewedAt
      createdAt
      updatedAt
    }
  }
`;
export const createLessonComment = /* GraphQL */ `
  mutation CreateLessonComment(
    $input: CreateLessonCommentInput!
    $condition: ModelLessonCommentConditionInput
  ) {
    createLessonComment(input: $input, condition: $condition) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLessonComment = /* GraphQL */ `
  mutation UpdateLessonComment(
    $input: UpdateLessonCommentInput!
    $condition: ModelLessonCommentConditionInput
  ) {
    updateLessonComment(input: $input, condition: $condition) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLessonComment = /* GraphQL */ `
  mutation DeleteLessonComment(
    $input: DeleteLessonCommentInput!
    $condition: ModelLessonCommentConditionInput
  ) {
    deleteLessonComment(input: $input, condition: $condition) {
      id
      lessonID
      courseID
      userID
      parentCommentID
      displayName
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createLessonCommentLike = /* GraphQL */ `
  mutation CreateLessonCommentLike(
    $input: CreateLessonCommentLikeInput!
    $condition: ModelLessonCommentLikeConditionInput
  ) {
    createLessonCommentLike(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLessonCommentLike = /* GraphQL */ `
  mutation UpdateLessonCommentLike(
    $input: UpdateLessonCommentLikeInput!
    $condition: ModelLessonCommentLikeConditionInput
  ) {
    updateLessonCommentLike(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLessonCommentLike = /* GraphQL */ `
  mutation DeleteLessonCommentLike(
    $input: DeleteLessonCommentLikeInput!
    $condition: ModelLessonCommentLikeConditionInput
  ) {
    deleteLessonCommentLike(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createLessonCommentReport = /* GraphQL */ `
  mutation CreateLessonCommentReport(
    $input: CreateLessonCommentReportInput!
    $condition: ModelLessonCommentReportConditionInput
  ) {
    createLessonCommentReport(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLessonCommentReport = /* GraphQL */ `
  mutation UpdateLessonCommentReport(
    $input: UpdateLessonCommentReportInput!
    $condition: ModelLessonCommentReportConditionInput
  ) {
    updateLessonCommentReport(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLessonCommentReport = /* GraphQL */ `
  mutation DeleteLessonCommentReport(
    $input: DeleteLessonCommentReportInput!
    $condition: ModelLessonCommentReportConditionInput
  ) {
    deleteLessonCommentReport(input: $input, condition: $condition) {
      id
      lessonID
      commentID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createLessonProgress = /* GraphQL */ `
  mutation CreateLessonProgress(
    $input: CreateLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    createLessonProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLessonProgress = /* GraphQL */ `
  mutation UpdateLessonProgress(
    $input: UpdateLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    updateLessonProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLessonProgress = /* GraphQL */ `
  mutation DeleteLessonProgress(
    $input: DeleteLessonProgressInput!
    $condition: ModelLessonProgressConditionInput
  ) {
    deleteLessonProgress(input: $input, condition: $condition) {
      id
      userID
      courseID
      lessonID
      playedSeconds
      videoIndex
      percentComplete
      completed
      lastWatchedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createVibePointTransaction = /* GraphQL */ `
  mutation CreateVibePointTransaction(
    $input: CreateVibePointTransactionInput!
    $condition: ModelVibePointTransactionConditionInput
  ) {
    createVibePointTransaction(input: $input, condition: $condition) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateVibePointTransaction = /* GraphQL */ `
  mutation UpdateVibePointTransaction(
    $input: UpdateVibePointTransactionInput!
    $condition: ModelVibePointTransactionConditionInput
  ) {
    updateVibePointTransaction(input: $input, condition: $condition) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteVibePointTransaction = /* GraphQL */ `
  mutation DeleteVibePointTransaction(
    $input: DeleteVibePointTransactionInput!
    $condition: ModelVibePointTransactionConditionInput
  ) {
    deleteVibePointTransaction(input: $input, condition: $condition) {
      id
      userID
      sourceType
      sourceID
      title
      description
      points
      earnedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUserNotification = /* GraphQL */ `
  mutation CreateUserNotification(
    $input: CreateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    createUserNotification(input: $input, condition: $condition) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const updateUserNotification = /* GraphQL */ `
  mutation UpdateUserNotification(
    $input: UpdateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    updateUserNotification(input: $input, condition: $condition) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserNotification = /* GraphQL */ `
  mutation DeleteUserNotification(
    $input: DeleteUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    deleteUserNotification(input: $input, condition: $condition) {
      id
      userID
      type
      title
      body
      link
      isRead
      createdAt
      updatedAt
    }
  }
`;
export const createStudentVideo = /* GraphQL */ `
  mutation CreateStudentVideo(
    $input: CreateStudentVideoInput!
    $condition: ModelStudentVideoConditionInput
  ) {
    createStudentVideo(input: $input, condition: $condition) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideo = /* GraphQL */ `
  mutation UpdateStudentVideo(
    $input: UpdateStudentVideoInput!
    $condition: ModelStudentVideoConditionInput
  ) {
    updateStudentVideo(input: $input, condition: $condition) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideo = /* GraphQL */ `
  mutation DeleteStudentVideo(
    $input: DeleteStudentVideoInput!
    $condition: ModelStudentVideoConditionInput
  ) {
    deleteStudentVideo(input: $input, condition: $condition) {
      id
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      thumbnailKey
      optimizedVideoKey
      hlsManifestKey
      transcodingStatus
      transcodingJobID
      transcodingError
      lessonID
      lessonTitle
      courseID
      courseTitle
      danceType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentVideoLike = /* GraphQL */ `
  mutation CreateStudentVideoLike(
    $input: CreateStudentVideoLikeInput!
    $condition: ModelStudentVideoLikeConditionInput
  ) {
    createStudentVideoLike(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideoLike = /* GraphQL */ `
  mutation UpdateStudentVideoLike(
    $input: UpdateStudentVideoLikeInput!
    $condition: ModelStudentVideoLikeConditionInput
  ) {
    updateStudentVideoLike(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideoLike = /* GraphQL */ `
  mutation DeleteStudentVideoLike(
    $input: DeleteStudentVideoLikeInput!
    $condition: ModelStudentVideoLikeConditionInput
  ) {
    deleteStudentVideoLike(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentVideoComment = /* GraphQL */ `
  mutation CreateStudentVideoComment(
    $input: CreateStudentVideoCommentInput!
    $condition: ModelStudentVideoCommentConditionInput
  ) {
    createStudentVideoComment(input: $input, condition: $condition) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideoComment = /* GraphQL */ `
  mutation UpdateStudentVideoComment(
    $input: UpdateStudentVideoCommentInput!
    $condition: ModelStudentVideoCommentConditionInput
  ) {
    updateStudentVideoComment(input: $input, condition: $condition) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideoComment = /* GraphQL */ `
  mutation DeleteStudentVideoComment(
    $input: DeleteStudentVideoCommentInput!
    $condition: ModelStudentVideoCommentConditionInput
  ) {
    deleteStudentVideoComment(input: $input, condition: $condition) {
      id
      videoID
      userID
      parentCommentID
      displayName
      profileImageKey
      body
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentPublicProfile = /* GraphQL */ `
  mutation CreateStudentPublicProfile(
    $input: CreateStudentPublicProfileInput!
    $condition: ModelStudentPublicProfileConditionInput
  ) {
    createStudentPublicProfile(input: $input, condition: $condition) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const updateStudentPublicProfile = /* GraphQL */ `
  mutation UpdateStudentPublicProfile(
    $input: UpdateStudentPublicProfileInput!
    $condition: ModelStudentPublicProfileConditionInput
  ) {
    updateStudentPublicProfile(input: $input, condition: $condition) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const deleteStudentPublicProfile = /* GraphQL */ `
  mutation DeleteStudentPublicProfile(
    $input: DeleteStudentPublicProfileInput!
    $condition: ModelStudentPublicProfileConditionInput
  ) {
    deleteStudentPublicProfile(input: $input, condition: $condition) {
      id
      userID
      username
      displayName
      profileImageKey
      bio
      city
      danceLevel
      favoriteStyles
      joinedAt
      updatedAt
      createdAt
      owner
    }
  }
`;
export const createStudentFollow = /* GraphQL */ `
  mutation CreateStudentFollow(
    $input: CreateStudentFollowInput!
    $condition: ModelStudentFollowConditionInput
  ) {
    createStudentFollow(input: $input, condition: $condition) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentFollow = /* GraphQL */ `
  mutation UpdateStudentFollow(
    $input: UpdateStudentFollowInput!
    $condition: ModelStudentFollowConditionInput
  ) {
    updateStudentFollow(input: $input, condition: $condition) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentFollow = /* GraphQL */ `
  mutation DeleteStudentFollow(
    $input: DeleteStudentFollowInput!
    $condition: ModelStudentFollowConditionInput
  ) {
    deleteStudentFollow(input: $input, condition: $condition) {
      id
      followerID
      followingID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentVideoBookmark = /* GraphQL */ `
  mutation CreateStudentVideoBookmark(
    $input: CreateStudentVideoBookmarkInput!
    $condition: ModelStudentVideoBookmarkConditionInput
  ) {
    createStudentVideoBookmark(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideoBookmark = /* GraphQL */ `
  mutation UpdateStudentVideoBookmark(
    $input: UpdateStudentVideoBookmarkInput!
    $condition: ModelStudentVideoBookmarkConditionInput
  ) {
    updateStudentVideoBookmark(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideoBookmark = /* GraphQL */ `
  mutation DeleteStudentVideoBookmark(
    $input: DeleteStudentVideoBookmarkInput!
    $condition: ModelStudentVideoBookmarkConditionInput
  ) {
    deleteStudentVideoBookmark(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentVideoView = /* GraphQL */ `
  mutation CreateStudentVideoView(
    $input: CreateStudentVideoViewInput!
    $condition: ModelStudentVideoViewConditionInput
  ) {
    createStudentVideoView(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideoView = /* GraphQL */ `
  mutation UpdateStudentVideoView(
    $input: UpdateStudentVideoViewInput!
    $condition: ModelStudentVideoViewConditionInput
  ) {
    updateStudentVideoView(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideoView = /* GraphQL */ `
  mutation DeleteStudentVideoView(
    $input: DeleteStudentVideoViewInput!
    $condition: ModelStudentVideoViewConditionInput
  ) {
    deleteStudentVideoView(input: $input, condition: $condition) {
      id
      videoID
      userID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createStudentVideoFeature = /* GraphQL */ `
  mutation CreateStudentVideoFeature(
    $input: CreateStudentVideoFeatureInput!
    $condition: ModelStudentVideoFeatureConditionInput
  ) {
    createStudentVideoFeature(input: $input, condition: $condition) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const updateStudentVideoFeature = /* GraphQL */ `
  mutation UpdateStudentVideoFeature(
    $input: UpdateStudentVideoFeatureInput!
    $condition: ModelStudentVideoFeatureConditionInput
  ) {
    updateStudentVideoFeature(input: $input, condition: $condition) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteStudentVideoFeature = /* GraphQL */ `
  mutation DeleteStudentVideoFeature(
    $input: DeleteStudentVideoFeatureInput!
    $condition: ModelStudentVideoFeatureConditionInput
  ) {
    deleteStudentVideoFeature(input: $input, condition: $condition) {
      id
      videoID
      label
      startsAt
      endsAt
      createdAt
      updatedAt
    }
  }
`;
export const createStudentModerationAction = /* GraphQL */ `
  mutation CreateStudentModerationAction(
    $input: CreateStudentModerationActionInput!
    $condition: ModelStudentModerationActionConditionInput
  ) {
    createStudentModerationAction(input: $input, condition: $condition) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const updateStudentModerationAction = /* GraphQL */ `
  mutation UpdateStudentModerationAction(
    $input: UpdateStudentModerationActionInput!
    $condition: ModelStudentModerationActionConditionInput
  ) {
    updateStudentModerationAction(input: $input, condition: $condition) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteStudentModerationAction = /* GraphQL */ `
  mutation DeleteStudentModerationAction(
    $input: DeleteStudentModerationActionInput!
    $condition: ModelStudentModerationActionConditionInput
  ) {
    deleteStudentModerationAction(input: $input, condition: $condition) {
      id
      userID
      action
      reason
      active
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createStudentVideoReport = /* GraphQL */ `
  mutation CreateStudentVideoReport(
    $input: CreateStudentVideoReportInput!
    $condition: ModelStudentVideoReportConditionInput
  ) {
    createStudentVideoReport(input: $input, condition: $condition) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateStudentVideoReport = /* GraphQL */ `
  mutation UpdateStudentVideoReport(
    $input: UpdateStudentVideoReportInput!
    $condition: ModelStudentVideoReportConditionInput
  ) {
    updateStudentVideoReport(input: $input, condition: $condition) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteStudentVideoReport = /* GraphQL */ `
  mutation DeleteStudentVideoReport(
    $input: DeleteStudentVideoReportInput!
    $condition: ModelStudentVideoReportConditionInput
  ) {
    deleteStudentVideoReport(input: $input, condition: $condition) {
      id
      videoID
      userID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createJourneyTrack = /* GraphQL */ `
  mutation CreateJourneyTrack(
    $input: CreateJourneyTrackInput!
    $condition: ModelJourneyTrackConditionInput
  ) {
    createJourneyTrack(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateJourneyTrack = /* GraphQL */ `
  mutation UpdateJourneyTrack(
    $input: UpdateJourneyTrackInput!
    $condition: ModelJourneyTrackConditionInput
  ) {
    updateJourneyTrack(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteJourneyTrack = /* GraphQL */ `
  mutation DeleteJourneyTrack(
    $input: DeleteJourneyTrackInput!
    $condition: ModelJourneyTrackConditionInput
  ) {
    deleteJourneyTrack(input: $input, condition: $condition) {
      id
      title
      slug
      description
      coverImageUrl
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyUnit = /* GraphQL */ `
  mutation CreateJourneyUnit(
    $input: CreateJourneyUnitInput!
    $condition: ModelJourneyUnitConditionInput
  ) {
    createJourneyUnit(input: $input, condition: $condition) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateJourneyUnit = /* GraphQL */ `
  mutation UpdateJourneyUnit(
    $input: UpdateJourneyUnitInput!
    $condition: ModelJourneyUnitConditionInput
  ) {
    updateJourneyUnit(input: $input, condition: $condition) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteJourneyUnit = /* GraphQL */ `
  mutation DeleteJourneyUnit(
    $input: DeleteJourneyUnitInput!
    $condition: ModelJourneyUnitConditionInput
  ) {
    deleteJourneyUnit(input: $input, condition: $condition) {
      id
      journeyID
      title
      description
      theme
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyNode = /* GraphQL */ `
  mutation CreateJourneyNode(
    $input: CreateJourneyNodeInput!
    $condition: ModelJourneyNodeConditionInput
  ) {
    createJourneyNode(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateJourneyNode = /* GraphQL */ `
  mutation UpdateJourneyNode(
    $input: UpdateJourneyNodeInput!
    $condition: ModelJourneyNodeConditionInput
  ) {
    updateJourneyNode(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteJourneyNode = /* GraphQL */ `
  mutation DeleteJourneyNode(
    $input: DeleteJourneyNodeInput!
    $condition: ModelJourneyNodeConditionInput
  ) {
    deleteJourneyNode(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      lessonID
      journeyLessonID
      title
      slug
      nodeType
      description
      cultureContent
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyLesson = /* GraphQL */ `
  mutation CreateJourneyLesson(
    $input: CreateJourneyLessonInput!
    $condition: ModelJourneyLessonConditionInput
  ) {
    createJourneyLesson(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateJourneyLesson = /* GraphQL */ `
  mutation UpdateJourneyLesson(
    $input: UpdateJourneyLessonInput!
    $condition: ModelJourneyLessonConditionInput
  ) {
    updateJourneyLesson(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteJourneyLesson = /* GraphQL */ `
  mutation DeleteJourneyLesson(
    $input: DeleteJourneyLessonInput!
    $condition: ModelJourneyLessonConditionInput
  ) {
    deleteJourneyLesson(input: $input, condition: $condition) {
      id
      journeyID
      unitID
      title
      slug
      description
      videoUrl
      videoProvider
      thumbnailUrl
      durationMinutes
      passingScore
      vpReward
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyQuizQuestion = /* GraphQL */ `
  mutation CreateJourneyQuizQuestion(
    $input: CreateJourneyQuizQuestionInput!
    $condition: ModelJourneyQuizQuestionConditionInput
  ) {
    createJourneyQuizQuestion(input: $input, condition: $condition) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateJourneyQuizQuestion = /* GraphQL */ `
  mutation UpdateJourneyQuizQuestion(
    $input: UpdateJourneyQuizQuestionInput!
    $condition: ModelJourneyQuizQuestionConditionInput
  ) {
    updateJourneyQuizQuestion(input: $input, condition: $condition) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteJourneyQuizQuestion = /* GraphQL */ `
  mutation DeleteJourneyQuizQuestion(
    $input: DeleteJourneyQuizQuestionInput!
    $condition: ModelJourneyQuizQuestionConditionInput
  ) {
    deleteJourneyQuizQuestion(input: $input, condition: $condition) {
      id
      journeyLessonID
      prompt
      options
      correctOption
      explanation
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createJourneyNodeProgress = /* GraphQL */ `
  mutation CreateJourneyNodeProgress(
    $input: CreateJourneyNodeProgressInput!
    $condition: ModelJourneyNodeProgressConditionInput
  ) {
    createJourneyNodeProgress(input: $input, condition: $condition) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateJourneyNodeProgress = /* GraphQL */ `
  mutation UpdateJourneyNodeProgress(
    $input: UpdateJourneyNodeProgressInput!
    $condition: ModelJourneyNodeProgressConditionInput
  ) {
    updateJourneyNodeProgress(input: $input, condition: $condition) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteJourneyNodeProgress = /* GraphQL */ `
  mutation DeleteJourneyNodeProgress(
    $input: DeleteJourneyNodeProgressInput!
    $condition: ModelJourneyNodeProgressConditionInput
  ) {
    deleteJourneyNodeProgress(input: $input, condition: $condition) {
      id
      userID
      journeyID
      journeyNodeID
      completed
      earnedVP
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createDanceChallenge = /* GraphQL */ `
  mutation CreateDanceChallenge(
    $input: CreateDanceChallengeInput!
    $condition: ModelDanceChallengeConditionInput
  ) {
    createDanceChallenge(input: $input, condition: $condition) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateDanceChallenge = /* GraphQL */ `
  mutation UpdateDanceChallenge(
    $input: UpdateDanceChallengeInput!
    $condition: ModelDanceChallengeConditionInput
  ) {
    updateDanceChallenge(input: $input, condition: $condition) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteDanceChallenge = /* GraphQL */ `
  mutation DeleteDanceChallenge(
    $input: DeleteDanceChallengeInput!
    $condition: ModelDanceChallengeConditionInput
  ) {
    deleteDanceChallenge(input: $input, condition: $condition) {
      id
      title
      slug
      description
      rules
      coverImageUrl
      demoVideoUrl
      startAt
      submissionEndsAt
      votingEndsAt
      participationPoints
      winnerPoints
      runnerUpPoints
      thirdPlacePoints
      quizTitle
      quizDescription
      quizPassingScore
      quizPoints
      status
      createdAt
      updatedAt
    }
  }
`;
export const createChallengeQuiz = /* GraphQL */ `
  mutation CreateChallengeQuiz(
    $input: CreateChallengeQuizInput!
    $condition: ModelChallengeQuizConditionInput
  ) {
    createChallengeQuiz(input: $input, condition: $condition) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateChallengeQuiz = /* GraphQL */ `
  mutation UpdateChallengeQuiz(
    $input: UpdateChallengeQuizInput!
    $condition: ModelChallengeQuizConditionInput
  ) {
    updateChallengeQuiz(input: $input, condition: $condition) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteChallengeQuiz = /* GraphQL */ `
  mutation DeleteChallengeQuiz(
    $input: DeleteChallengeQuizInput!
    $condition: ModelChallengeQuizConditionInput
  ) {
    deleteChallengeQuiz(input: $input, condition: $condition) {
      id
      challengeID
      title
      description
      coverImageUrl
      mediaType
      mediaUrl
      mediaCaption
      passingScore
      points
      status
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createChallengeQuizLibrarySettings = /* GraphQL */ `
  mutation CreateChallengeQuizLibrarySettings(
    $input: CreateChallengeQuizLibrarySettingsInput!
    $condition: ModelChallengeQuizLibrarySettingsConditionInput
  ) {
    createChallengeQuizLibrarySettings(input: $input, condition: $condition) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateChallengeQuizLibrarySettings = /* GraphQL */ `
  mutation UpdateChallengeQuizLibrarySettings(
    $input: UpdateChallengeQuizLibrarySettingsInput!
    $condition: ModelChallengeQuizLibrarySettingsConditionInput
  ) {
    updateChallengeQuizLibrarySettings(input: $input, condition: $condition) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteChallengeQuizLibrarySettings = /* GraphQL */ `
  mutation DeleteChallengeQuizLibrarySettings(
    $input: DeleteChallengeQuizLibrarySettingsInput!
    $condition: ModelChallengeQuizLibrarySettingsConditionInput
  ) {
    deleteChallengeQuizLibrarySettings(input: $input, condition: $condition) {
      id
      title
      description
      createdAt
      updatedAt
    }
  }
`;
export const createChallengeQuizQuestion = /* GraphQL */ `
  mutation CreateChallengeQuizQuestion(
    $input: CreateChallengeQuizQuestionInput!
    $condition: ModelChallengeQuizQuestionConditionInput
  ) {
    createChallengeQuizQuestion(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const updateChallengeQuizQuestion = /* GraphQL */ `
  mutation UpdateChallengeQuizQuestion(
    $input: UpdateChallengeQuizQuestionInput!
    $condition: ModelChallengeQuizQuestionConditionInput
  ) {
    updateChallengeQuizQuestion(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const deleteChallengeQuizQuestion = /* GraphQL */ `
  mutation DeleteChallengeQuizQuestion(
    $input: DeleteChallengeQuizQuestionInput!
    $condition: ModelChallengeQuizQuestionConditionInput
  ) {
    deleteChallengeQuizQuestion(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      prompt
      options
      correctOption
      explanation
      mediaType
      mediaUrl
      mediaCaption
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
export const createChallengeQuizAttempt = /* GraphQL */ `
  mutation CreateChallengeQuizAttempt(
    $input: CreateChallengeQuizAttemptInput!
    $condition: ModelChallengeQuizAttemptConditionInput
  ) {
    createChallengeQuizAttempt(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChallengeQuizAttempt = /* GraphQL */ `
  mutation UpdateChallengeQuizAttempt(
    $input: UpdateChallengeQuizAttemptInput!
    $condition: ModelChallengeQuizAttemptConditionInput
  ) {
    updateChallengeQuizAttempt(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChallengeQuizAttempt = /* GraphQL */ `
  mutation DeleteChallengeQuizAttempt(
    $input: DeleteChallengeQuizAttemptInput!
    $condition: ModelChallengeQuizAttemptConditionInput
  ) {
    deleteChallengeQuizAttempt(input: $input, condition: $condition) {
      id
      challengeID
      quizID
      roundKey
      userID
      displayName
      profileImageKey
      answers
      score
      totalQuestions
      passed
      earnedPoints
      completedAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createChallengeSubmission = /* GraphQL */ `
  mutation CreateChallengeSubmission(
    $input: CreateChallengeSubmissionInput!
    $condition: ModelChallengeSubmissionConditionInput
  ) {
    createChallengeSubmission(input: $input, condition: $condition) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChallengeSubmission = /* GraphQL */ `
  mutation UpdateChallengeSubmission(
    $input: UpdateChallengeSubmissionInput!
    $condition: ModelChallengeSubmissionConditionInput
  ) {
    updateChallengeSubmission(input: $input, condition: $condition) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChallengeSubmission = /* GraphQL */ `
  mutation DeleteChallengeSubmission(
    $input: DeleteChallengeSubmissionInput!
    $condition: ModelChallengeSubmissionConditionInput
  ) {
    deleteChallengeSubmission(input: $input, condition: $condition) {
      id
      challengeID
      roundKey
      userID
      displayName
      profileImageKey
      videoKey
      videoMimeType
      caption
      status
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createChallengeLike = /* GraphQL */ `
  mutation CreateChallengeLike(
    $input: CreateChallengeLikeInput!
    $condition: ModelChallengeLikeConditionInput
  ) {
    createChallengeLike(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChallengeLike = /* GraphQL */ `
  mutation UpdateChallengeLike(
    $input: UpdateChallengeLikeInput!
    $condition: ModelChallengeLikeConditionInput
  ) {
    updateChallengeLike(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChallengeLike = /* GraphQL */ `
  mutation DeleteChallengeLike(
    $input: DeleteChallengeLikeInput!
    $condition: ModelChallengeLikeConditionInput
  ) {
    deleteChallengeLike(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createChallengeView = /* GraphQL */ `
  mutation CreateChallengeView(
    $input: CreateChallengeViewInput!
    $condition: ModelChallengeViewConditionInput
  ) {
    createChallengeView(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChallengeView = /* GraphQL */ `
  mutation UpdateChallengeView(
    $input: UpdateChallengeViewInput!
    $condition: ModelChallengeViewConditionInput
  ) {
    updateChallengeView(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChallengeView = /* GraphQL */ `
  mutation DeleteChallengeView(
    $input: DeleteChallengeViewInput!
    $condition: ModelChallengeViewConditionInput
  ) {
    deleteChallengeView(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createChallengeReport = /* GraphQL */ `
  mutation CreateChallengeReport(
    $input: CreateChallengeReportInput!
    $condition: ModelChallengeReportConditionInput
  ) {
    createChallengeReport(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChallengeReport = /* GraphQL */ `
  mutation UpdateChallengeReport(
    $input: UpdateChallengeReportInput!
    $condition: ModelChallengeReportConditionInput
  ) {
    updateChallengeReport(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChallengeReport = /* GraphQL */ `
  mutation DeleteChallengeReport(
    $input: DeleteChallengeReportInput!
    $condition: ModelChallengeReportConditionInput
  ) {
    deleteChallengeReport(input: $input, condition: $condition) {
      id
      challengeID
      submissionID
      reason
      details
      resolved
      createdAt
      updatedAt
      owner
    }
  }
`;
